/* Mirror the original PDP button; never submit a separate cart request. */
(function () {
  'use strict';
  if (window.sigiStickyAtcInstalled) return;
  window.sigiStickyAtcInstalled = true;

  var cleanup = function () {};
  function init() {
    cleanup();
    cleanup = function () {};
    if (!document.body.classList.contains('template-product') ||
        !window.IntersectionObserver || !window.MutationObserver) return;

    var sources = document.querySelectorAll(
      '#MainContent [data-sigi-sticky-atc-source][data-enable-history-state="true"]'
    );
    if (sources.length !== 1 || sources[0].closest('.modal')) return;
    var source = sources[0];
    var form = source.querySelector('form.product-single__form');
    var original = form && form.querySelector('button[name="add"].add-to-cart');
    var price = source.querySelector('[id^="ProductPrice-"]');
    if (!original || original.form !== form || original.type !== 'submit') return;
    var masterVariant = form.querySelector('select[name="id"].product-single__variants');
    var variantsJson = form.querySelector('[id^="VariantsJson-"]');
    var variants = [];
    try { variants = JSON.parse(variantsJson ? variantsJson.textContent : '[]'); } catch (error) { /* Keep the original controls. */ }
    if (!Array.isArray(variants)) variants = [];
    var optionControls = Array.prototype.filter.call(form.querySelectorAll('input[data-index], select[data-index]'), function (control) {
      return control.classList.contains('variant__input-' + source.getAttribute('data-section-id')) &&
        (control.type === 'radio' || control.tagName === 'SELECT');
    });
    function controlsForVariant(variant) {
      if (!Array.isArray(variant.options) || !variant.options.length) return [];
      return variant.options.map(function (value, index) {
        return optionControls.find(function (control) {
          if (control.getAttribute('data-index') !== 'option' + (index + 1)) return false;
          return control.type === 'radio' ? control.value === value :
            Array.prototype.some.call(control.options, function (option) { return option.value === value; });
        });
      });
    }
    var hasVariants = !!masterVariant && variants.length > 1 && variants.every(function (variant) {
      var controls = controlsForVariant(variant);
      return variant.id && variant.title && controls.length && controls.every(Boolean);
    });
    function swatchesForVariant(variant) {
      // Globo adds required radios alongside the theme's hidden option controls.
      // Read them afresh because the app can insert/replace them after init.
      var swatches = Array.prototype.slice.call(form.querySelectorAll('input[type="radio"][data-globoswatchindex]'));
      var indexes = [];
      swatches.forEach(function (control) {
        var index = control.getAttribute('data-globoswatchindex');
        if (/^option[1-3]$/.test(index) && indexes.indexOf(index) === -1) indexes.push(index);
      });
      return indexes.map(function (index) {
        return swatches.find(function (control) {
          return control.getAttribute('data-globoswatchindex') === index && control.value === variant[index];
        });
      });
    }
    function selectedVariant() {
      return variants.find(function (variant) {
        return controlsForVariant(variant).every(function (control, index) {
          return control && (control.type === 'radio' ? control.checked : control.value === variant.options[index]);
        }) && swatchesForVariant(variant).every(function (control) { return control && control.checked; });
      });
    }
    function canSelectVariant(variant) {
      return !masterVariant.disabled && controlsForVariant(variant).every(function (control, index) {
        if (!control || control.disabled) return false;
        return control.type === 'radio' || Array.prototype.some.call(control.options, function (option) {
          return option.value === variant.options[index] && !option.disabled;
        });
      }) && swatchesForVariant(variant).every(function (control) { return control && !control.disabled; });
    }
    var quantity = form.querySelector('input[name="quantity"].js-qty__num');
    var quantityWrapper = quantity && quantity.closest('.js-qty__wrapper');
    var originalMinus = quantityWrapper && quantityWrapper.querySelector('button.js-qty__adjust--minus');
    var originalPlus = quantityWrapper && quantityWrapper.querySelector('button.js-qty__adjust--plus');
    var hasQuantity = !hasVariants && quantity && originalMinus && originalPlus &&
      originalMinus.type === 'button' && originalPlus.type === 'button';

    var mobile = window.matchMedia('all');
    var bar = document.createElement('div');
    bar.className = 'sigi-sticky-atc';
    bar.hidden = true;
    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'sigi-sticky-atc__button';
    button.setAttribute('aria-controls', form.getAttribute('id'));
    var labelSpan = document.createElement('span');
    labelSpan.className = 'sigi-sticky-atc__label';
    var priceSpan = document.createElement('span');
    priceSpan.className = 'sigi-sticky-atc__price';
    priceSpan.setAttribute('aria-hidden', 'true');
    button.append(labelSpan, priceSpan);
    var variantSelect;
    if (hasVariants) {
      variantSelect = document.createElement('select');
      variantSelect.className = 'sigi-sticky-atc__variant';
      variantSelect.setAttribute('aria-label', 'Choose product variant');
      variantSelect.setAttribute('aria-controls', form.getAttribute('id'));
      var placeholder = document.createElement('option');
      placeholder.value = '';
      var optionName = optionControls[0].getAttribute('name');
      placeholder.textContent = variants[0].options.length === 1 && optionName ? 'Select ' + optionName.toLowerCase() : 'Select variant';
      placeholder.disabled = true;
      placeholder.hidden = true;
      variantSelect.appendChild(placeholder);
      variants.forEach(function (variant) {
        var option = document.createElement('option');
        option.value = String(variant.id);
        option.textContent = variant.title;
        variantSelect.appendChild(option);
      });
      bar.appendChild(variantSelect);
    }
    var minus, plus, quantityValue;
    if (hasQuantity) {
      var quantityGroup = document.createElement('div');
      quantityGroup.className = 'sigi-sticky-atc__quantity';
      quantityGroup.setAttribute('role', 'group');
      quantityGroup.setAttribute('aria-label', 'Quantity');
      minus = document.createElement('button');
      minus.type = 'button';
      minus.className = 'sigi-sticky-atc__adjust';
      minus.textContent = '−';
      minus.setAttribute('aria-label', 'Decrease quantity');
      plus = document.createElement('button');
      plus.type = 'button';
      plus.className = 'sigi-sticky-atc__adjust';
      plus.textContent = '+';
      plus.setAttribute('aria-label', 'Increase quantity');
      quantityValue = document.createElement('span');
      quantityValue.className = 'sigi-sticky-atc__quantity-value';
      quantityValue.setAttribute('role', 'status');
      quantityValue.setAttribute('aria-live', 'polite');
      quantityValue.setAttribute('aria-atomic', 'true');
      quantityGroup.append(minus, quantityValue, plus);
      bar.appendChild(quantityGroup);
    }
    bar.appendChild(button);
    var space = document.createElement('div');
    space.className = 'sigi-sticky-atc-space';
    space.setAttribute('aria-hidden', 'true');
    document.body.append(space, bar);

    var frame = 0;
    var submitFrame = 0;
    var disposed = false;
    var tapLocked = false;
    var lockUntil = 0;
    var lockTimer = 0;
    var forwardingClick = false;
    var submitSeen = false;
    var waitingForFeedback = false;
    var quantityResetUntil = 0;
    var addSucceeded = false;
    var previousError;
    var previousErrorText = '';
    var errorSelector = '.errors, .ajaxified-cart-feedback.error';
    var overlaySelector = '.drawer, .modal, .pswp, .site-header__search-container, dialog, [role="dialog"]';
    var bodyState = '.js-drawer-open, .js-drawer-closing, .modal-open, .modal-closing';
    var listeners = [];

    function text(node) {
      return node ? node.textContent.replace(/\s+/g, ' ').trim() : '';
    }
    function productPrice() {
      if (!price) return '';
      // Extract one money token, never payment-app sentences or bare numbers.
      var amount = '(?:\\d{1,3}(?:[, .\\u00a0\\u202f]\\d{3})+|\\d+)(?:[.,]\\d{1,2})?(?![\\d.,])';
      var codes = '(?:SGD|USD|AUD|CAD|NZD|HKD|MYR|RM|EUR|GBP|JPY|CNY|INR|IDR|Rp|KRW|VND|PHP|THB|TWD|CHF|AED|SAR|DKK|NOK|SEK|ZAR)';
      var symbols = '(?:[A-Z]{1,3})?[$€£¥₹₩₫₱฿₺₽₪]';
      var money = new RegExp('(?:(?:' + codes + '|' + symbols + ')\\s*' + amount +
        '(?:\\s*' + codes + '\\b)?|' + amount + '\\s*(?:' + codes + '\\b|[$€£¥₹₩₫₱฿₺₽₪]))');
      // Prefer the theme's own text over app-injected descendants when available.
      var direct = Array.prototype.map.call(price.childNodes, function (node) {
        return node.nodeType === 3 ? node.textContent : '';
      }).join(' ');
      var match = direct.match(money) || text(price).match(money);
      return match ? match[0].replace(/\s+/g, ' ').trim() : '';
    }
    function quantityState() {
      var value = Number(quantity.value);
      var min = Math.max(1, Number(quantity.getAttribute('min')) || 1);
      var max = Number(quantity.getAttribute('max')) || Infinity;
      var valid = Number.isSafeInteger(value) && value >= min;
      var blocked = tapLocked || state().disabled || quantity.disabled || quantity.readOnly;
      return { value: value, min: min, max: max, valid: valid, blocked: blocked };
    }
    function syncQuantity(value, notify) {
      if (!hasQuantity) return;
      var current = quantityState();
      var next = Number(value === undefined ? quantity.value : value);
      if (!Number.isSafeInteger(next) || next < current.min) next = current.min;
      next = String(Math.min(next, Math.max(current.min, current.max)));
      var changed = quantity.value !== next;
      quantity.value = next;
      if (quantityValue.textContent !== next) quantityValue.textContent = next;
      if (notify || changed) {
        quantity.dispatchEvent(new Event('input', { bubbles: true }));
        quantity.dispatchEvent(new Event('change', { bubbles: true }));
        // Keep the displayed selection authoritative through synchronous listeners.
        quantity.value = next;
      }
      current = quantityState();
      minus.disabled = current.blocked || originalMinus.disabled || current.value <= current.min;
      plus.disabled = current.blocked || originalPlus.disabled || current.value >= current.max;
    }
    function changeQuantity(direction) {
      if (bar.hidden || !mobile.matches || overlayOpen()) return;
      var current = quantityState();
      var control = direction < 0 ? originalMinus : originalPlus;
      var displayed = Number(quantityValue.textContent);
      if (current.blocked || control.disabled ||
          (direction < 0 ? displayed <= current.min : displayed >= current.max)) return;
      // Update the original input directly; its change handler handles theme events.
      syncQuantity(displayed + direction, true);
      schedule();
    }
    function syncVariant() {
      if (!hasVariants) return;
      var selected = selectedVariant();
      variantSelect.value = selected ? String(selected.id) : '';
      variants.forEach(function (variant, index) {
        variantSelect.options[index + 1].disabled = !canSelectVariant(variant);
      });
      // A sold-out selection must still allow switching to another size.
      variantSelect.disabled = tapLocked || state().busy || masterVariant.disabled;
    }
    function applyVariant(variant) {
      if (!variant || !canSelectVariant(variant)) return false;
      swatchesForVariant(variant).forEach(function (control) {
        var wasChecked = control.checked;
        // Use the same radio click path as the visible Size selector.
        control.click();
        if (wasChecked) {
          control.dispatchEvent(new Event('input', { bubbles: true }));
          control.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
      var controls = controlsForVariant(variant);
      controls.forEach(function (control, index) {
        if (control.type === 'radio') {
          control.checked = true;
        } else {
          control.value = variant.options[index];
        }
      });
      // Let the theme resolve the variant ID, price, availability and images.
      // Re-notify even an unchanged default value; the visible swatches may
      // not have been selected yet. Never bypass validation or write a cart ID.
      controls.forEach(function (control) {
        control.dispatchEvent(new Event('input', { bubbles: true }));
        control.dispatchEvent(new Event('change', { bubbles: true }));
      });
      return true;
    }
    function changeVariant() {
      var variant = variants.find(function (item) { return String(item.id) === variantSelect.value; });
      if (bar.hidden || tapLocked || state().busy || !mobile.matches || overlayOpen() ||
          !variant || !canSelectVariant(variant)) { syncVariant(); return; }
      applyVariant(variant);
      syncVariant();
      schedule();
    }
    function listen(target, event, callback, options) {
      target.addEventListener(event, callback, options);
      listeners.push(function () { target.removeEventListener(event, callback, options); });
    }
    function schedule() {
      if (!disposed && !frame) frame = window.requestAnimationFrame(update);
    }
    function state() {
      var label = text(original.querySelector('[id^="AddToCartText-"]') || original);
      var busy = original.classList.contains('btn--loading') ||
        original.getAttribute('aria-busy') === 'true' || /^Adding\.{3}$/.test(label);
      var selected = hasVariants && selectedVariant();
      var unresolved = hasVariants && (!selected ||
        (selected.available && String(masterVariant.value) !== String(selected.id)));
      return {
        label: busy ? 'Adding…' : (label || 'Add to Bag'),
        busy: busy,
        disabled: busy || original.disabled || original.classList.contains('disabled') || unresolved
      };
    }
    function returnToForm() {
      setVisible(false);
      form.scrollIntoView({ block: 'center', behavior: 'auto' });
      if (!original.disabled) original.focus({ preventScroll: true });
    }
    function visible(node) {
      return node.getClientRects().length > 0 &&
        getComputedStyle(node).visibility !== 'hidden' &&
        getComputedStyle(node).opacity !== '0';
    }
    function overlayOpen() {
      if (document.documentElement.matches(bodyState) || document.body.matches(bodyState)) return true;
      if (document.querySelector('.drawer--is-open, .modal--is-active, .modal--is-closing, .pswp--open, .site-header__search-container.is-active')) return true;
      return Array.prototype.some.call(document.querySelectorAll('dialog[open], [role="dialog"]'), function (node) {
        return node.getAttribute('aria-hidden') !== 'true' && visible(node);
      });
    }
    function editing() {
      var active = document.activeElement;
      while (active && active.shadowRoot && active.shadowRoot.activeElement) {
        active = active.shadowRoot.activeElement;
      }
      if (active && bar.contains(active)) return false;
      return active && (active.isContentEditable || active.matches(
        'textarea, select, input:not([type="radio"]):not([type="checkbox"]):not([type="button"]):not([type="submit"]):not([type="hidden"])'
      ));
    }
    function setVisible(show) {
      if (bar.hidden === show) bar.hidden = !show;
      if (document.body.classList.contains('sigi-sticky-atc-visible') !== show) {
        document.body.classList.toggle('sigi-sticky-atc-visible', show);
      }
      if (show) {
        // Reserve enough space at the page end so the bar cannot cover final links.
        space.style.setProperty('--sigi-sticky-atc-height', bar.offsetHeight + 'px');
      }
    }
    function update() {
      frame = 0;
      if (disposed) return;
      var current = state();
      if (tapLocked && !submitFrame && Date.now() >= lockUntil && !current.disabled && !overlayOpen()) {
        tapLocked = false;
      }
      var currentPrice = current.disabled ? '' : productPrice();
      var label = current.disabled ? current.label : 'Add to Bag';
      if (labelSpan.textContent !== label) labelSpan.textContent = label;
      if (priceSpan.textContent !== currentPrice) priceSpan.textContent = currentPrice;
      priceSpan.hidden = !currentPrice;
      button.setAttribute('aria-label', label + (currentPrice ? ' — ' + currentPrice : ''));
      button.disabled = tapLocked || current.disabled;
      button.setAttribute('aria-busy', String(current.busy));
      // Read the actual form value on mobile init/show and refreshes. Do not
      // rewrite a field while the customer is typing in the original form.
      if (mobile.matches && document.activeElement !== quantity) syncQuantity();
      syncVariant();

      var error = form.querySelector(errorSelector);
      if ((waitingForFeedback || quantityResetUntil) && error &&
          (error !== previousError || text(error) !== previousErrorText)) {
        waitingForFeedback = false;
        quantityResetUntil = 0;
        addSucceeded = false;
        returnToForm();
        return;
      }
      if (quantityResetUntil && Date.now() >= quantityResetUntil) {
        quantityResetUntil = 0;
        addSucceeded = false;
      }
      if (quantityResetUntil && addSucceeded && document.querySelector('#CartDrawer.drawer--is-open')) {
        quantityResetUntil = 0;
        addSucceeded = false;
        syncQuantity(1, true);
      }
      if (waitingForFeedback && !current.disabled) waitingForFeedback = false;
      setVisible(mobile.matches && !document.hidden && source.isConnected &&
        original.getClientRects().length > 0 && original.getBoundingClientRect().bottom <= 0 &&
        !overlayOpen() && !editing());
    }

    button.addEventListener('click', function () {
      if (bar.hidden || tapLocked || state().busy || !mobile.matches ||
          original.getBoundingClientRect().bottom > 0 || overlayOpen()) return;
      var requestedVariant = hasVariants && variants.find(function (item) { return String(item.id) === variantSelect.value; });
      if (hasVariants ? (!requestedVariant || !requestedVariant.available || !canSelectVariant(requestedVariant)) : state().disabled) return;
      tapLocked = true;
      lockUntil = Infinity;
      button.disabled = true;
      // Commit exactly the quantity the customer sees before the original
      // button serializes the form, even if its value changed silently.
      if (hasQuantity) syncQuantity(quantityValue.textContent, true);
      function forwardClick() {
        submitFrame = 0;
        if (disposed) return;
        if (!mobile.matches || overlayOpen() || document.hidden || !source.isConnected ||
            original.getBoundingClientRect().bottom > 0) {
          tapLocked = false;
          schedule();
          return;
        }
        var selected = hasVariants && selectedVariant();
        if ((hasVariants && (!selected || selected.id !== requestedVariant.id)) || state().disabled || !form.checkValidity()) {
          tapLocked = false;
          returnToForm();
          form.reportValidity();
          schedule();
          return;
        }
        previousError = form.querySelector(errorSelector);
        previousErrorText = text(previousError);
        waitingForFeedback = true;
        quantityResetUntil = hasQuantity ? Date.now() + 30000 : 0;
        addSucceeded = false;
        submitSeen = false;
        lockUntil = Date.now() + 1000;
        window.clearTimeout(lockTimer);
        lockTimer = window.setTimeout(schedule, 1000);
        forwardingClick = true;
        try {
          // Use the original button's existing form path, regardless of AJAX libraries.
          original.click();
        } finally {
          forwardingClick = false;
          schedule();
        }
      }
      if (hasVariants) {
        variantSelect.disabled = true;
        applyVariant(requestedVariant);
        // Give existing theme/app handlers one frame to settle before checking
        // the actual required controls and forwarding exactly one add click.
        submitFrame = window.requestAnimationFrame(forwardClick);
        schedule();
      } else {
        forwardClick();
      }
    });

    // Guard this sticky-triggered attempt only; ordinary form use is untouched.
    listen(original, 'click', function (event) {
      if (tapLocked && !forwardingClick) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    }, true);
    listen(form, 'submit', function (event) {
      if (!tapLocked) return;
      if (submitSeen) {
        event.preventDefault();
        event.stopImmediatePropagation();
        return;
      }
      submitSeen = true;
    }, true);

    // Observe the theme's existing success event; never issue a cart request.
    // A manual drawer opening or a failed add must not reset the selection.
    if (window.theme && window.theme.jQuery) {
      var themeBody = window.theme.jQuery(document.body);
      var successEvent = 'added.ajaxProduct.sigiStickyAtcQuantity';
      var onAdded = function () {
        if (!quantityResetUntil || Date.now() >= quantityResetUntil || !submitSeen) return;
        addSucceeded = true;
        schedule();
      };
      themeBody.on(successEvent, onAdded);
      listeners.push(function () { themeBody.off(successEvent, onAdded); });
    }

    if (hasQuantity) {
      listen(minus, 'click', function () { changeQuantity(-1); });
      listen(plus, 'click', function () { changeQuantity(1); });
      listen(quantityWrapper, 'click', schedule);
    }
    if (hasVariants) {
      listen(variantSelect, 'change', changeVariant);
      // Theme-triggered jQuery events do not always emit native change events.
      if (window.theme && window.theme.jQuery) {
        var themeSource = window.theme.jQuery(source);
        var variantEvents = 'variantChange.sigiStickyAtcVariant variantPriceChange.sigiStickyAtcVariant';
        themeSource.on(variantEvents, schedule);
        listeners.push(function () { themeSource.off(variantEvents, schedule); });
      }
    }

    var formObserver = new MutationObserver(schedule);
    formObserver.observe(form, {
      subtree: true, childList: true, characterData: true, attributes: true,
      attributeFilter: ['disabled', 'class', 'aria-busy', 'readonly', 'min', 'max', 'checked', 'selected', 'value']
    });
    if (price) formObserver.observe(price, { subtree: true, childList: true, characterData: true });
    var intersectionObserver = new IntersectionObserver(schedule);
    intersectionObserver.observe(original);

    var observedOverlays = new WeakSet();
    var overlayObserver = new MutationObserver(schedule);
    function watchOverlay(node) {
      if (observedOverlays.has(node)) return;
      observedOverlays.add(node);
      overlayObserver.observe(node, {
        attributes: true, attributeFilter: ['class', 'style', 'hidden', 'open', 'aria-hidden', 'aria-modal']
      });
    }
    watchOverlay(document.documentElement);
    watchOverlay(document.body);
    document.querySelectorAll(overlaySelector).forEach(watchOverlay);
    var insertedOverlayObserver = new MutationObserver(function (changes) {
      changes.forEach(function (change) {
        change.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.matches(overlaySelector)) { watchOverlay(node); schedule(); }
          node.querySelectorAll(overlaySelector).forEach(function (overlay) {
            watchOverlay(overlay);
            schedule();
          });
        });
        if (change.removedNodes.length) schedule();
      });
    });
    insertedOverlayObserver.observe(document.body, { childList: true, subtree: true });

    listen(window, 'scroll', schedule, { passive: true });
    listen(window, 'resize', schedule, { passive: true });
    listen(window, 'pageshow', schedule);
    listen(window, 'load', schedule);
    listen(document, 'visibilitychange', schedule);
    listen(document, 'focusin', schedule);
    listen(document, 'focusout', schedule);
    listen(form, 'change', schedule);
    listen(form, 'input', schedule);
    if (window.visualViewport) listen(window.visualViewport, 'resize', schedule, { passive: true });
    cleanup = function () {
      disposed = true;
      window.cancelAnimationFrame(frame);
      window.cancelAnimationFrame(submitFrame);
      window.clearTimeout(lockTimer);
      formObserver.disconnect();
      overlayObserver.disconnect();
      insertedOverlayObserver.disconnect();
      intersectionObserver.disconnect();
      listeners.forEach(function (remove) { remove(); });
      bar.remove();
      space.remove();
      document.body.classList.remove('sigi-sticky-atc-visible');
    };
    update();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', function (event) {
    if (event.target.matches('[data-sigi-sticky-atc-source]') ||
        event.target.querySelector('[data-sigi-sticky-atc-source]')) cleanup();
  });
})();
